import React, { useState } from 'react';
import styled from 'styled-components';

// components
import Text from 'components/common/Text';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import Translation from 'libs/Translation';

const Content = styled.div`
    margin-top: 20px;
    width: 100%;
    .accordion {
        margin-bottom: 15px;
        box-shadow: none !important;
        border-radius: 8px !important;
        width: 100%;
        padding: 7px 0px;
        .icon {
            width: 20px;
            height: 20px;
        }
        .question {
            padding: 0px 16px;
            height: auto;
            border: none !important;
            box-shadow: none !important;
            width: 100%;
            margin: -8px 0;
            p {
                margin: -2px 0 !important;
            }
            .question-text {
                line-height: 28px;
                width: 90%;
                box-shadow: none !important;
                border: none !important;
                font-size: 14px;
            }
        }
        .answer {
            width: 100%;
            margin-top: -13px;
            margin-bottom: -4px;
            border: none !important;
            box-shadow: none !important;
            p {
                margin: -1px 0 !important;
            }
            .answer-text {
                font-weight: 500;
                font-size: 13px;
                line-height: 26px;
                color: rgba(123, 123, 123, 1);
                box-shadow: none !important;
                border: none !important;
            }
        }
    }
`;

const Faq = ({ faq }) => {
	const [expanded, setExpanded] = useState(faq[0]?._id ?? faq[0]?.question);

	const handleChange = panel => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	return (
			<Content>
				{faq.map((f, index) => (
					<Accordion
                        key={index}
						className="accordion"
						expanded={f._id ? expanded === f._id : expanded === f.question}
						onChange={f._id ? handleChange(f._id) : handleChange(f.question)}
                        style={{ 
                            backgroundColor: 
                                expanded === f._id || expanded === f.question 
                                    ? 'rgba(245, 245, 247, 1)' 
                                    : 'rgba(255, 255, 255, 1)',
                            border: 
                                expanded === f._id || expanded === f.question 
                                    ? 'none'
                                    : '1px solid rgba(227, 227, 227, 1)'
                            }}
					>
						<AccordionSummary
							className="question"
							expandIcon={expanded === f._id || expanded === f.question 
                                ? <img src="/nextasset/images/minus.png" className='icon'/>
                                : <img src="/nextasset/images/add.png" className='icon'/> 
                            }
						>
							<div
								className="question-text"
								dangerouslySetInnerHTML={{ __html: Translation.n(f.question)}}
                                style={{ 
                                    color: 
                                        expanded === f._id || expanded === f.question 
                                            ? 'rgba(33, 43, 54, 1)' 
                                            : 'rgba(72, 75, 77, 1)',
                                    fontWeight: 
                                        expanded === f._id || expanded === f.question 
                                            ? '600' 
                                            : '500'
                                }}
							/>
						</AccordionSummary>
						<AccordionDetails className="answer">
							<div
								className="answer-text"
								dangerouslySetInnerHTML={{ __html: Translation.n(f.answer)}}
							/>
						</AccordionDetails>
					</Accordion>
				))}
			</Content>
	);
};

export default Faq;
